import React from 'react';
import clsx from 'clsx';
import { trackingId, useFocusVisibleIE, useResponsiveCtx } from '@blueprint/ui';

import IconWrapper from './IconWrapper';
import SelectTitle from './SelectTitle';
import SelectWrapper from './SelectWrapper';
import SelectBox from './SelectBox';

const Select = ({
  children,
  invalid = false,
  disabled = false,
  selectSize = 'large',
  mode = 'light',
  width = 'auto',
  selectTitle,
  className = '',
  ...rest
}) => {
  const selectClassname = clsx({
    disabled,
    invalid,
    small: selectSize === 'small',
    extraLarge: selectSize === 'extraLarge',
    dark: mode === 'dark',
    selectTitle,
  });
  const focusVisibleIE = useFocusVisibleIE(
    { ...rest, className: `${selectClassname} ${className}` },
    'mouse',
  );
  const { vMedia } = useResponsiveCtx();

  return (
    <SelectWrapper
      disabled={disabled}
      data-testid="NativeDropdown"
      data-trackid={trackingId('NativeDropdown')}
      width={width}
    >
      {selectTitle && (
        <SelectTitle className={selectClassname}>{selectTitle}</SelectTitle>
      )}
      {/* @ts-ignore */}
      <SelectBox
        as="select"
        selectTitle={selectTitle}
        disabled={disabled}
        {...rest}
        {...focusVisibleIE}
        vMedia={vMedia}
      >
        {children}
      </SelectBox>
      <IconWrapper
        mode={mode}
        selectTitle={selectTitle}
        className={selectClassname}
      />
    </SelectWrapper>
  );
};

Select.displayName = 'Select';

export default Select;
